

export const openAddJobDialogReducer = (state) => {
    state.addJobDialog.isOpen = true;
    state.createNewJob.status = "idle";
    state.createNewJob.errorMessage = "";
}